/*
;(function () {
    const infoCollapse = $('.Product_info_header')

    if (infoCollapse.length){
        infoCollapse.click(function (e) {
            console.log('ss')
            const field = $(this).attr('data-field')
            const parrentBlock = $('#'+field)
            if(parrentBlock.attr('data-show') === "true"){
                parrentBlock.attr('data-show',false)
            }else{
                parrentBlock.attr('data-show',true)
            }
        })
    }

})();
*/
$(document).ready(()=>{
    const infoCollapse = $('.Product_info_header')

    if (infoCollapse.length){
        infoCollapse.click(function (e) {
            console.log('ss')
            const field = $(this).attr('data-field')
            const parrentBlock = $('#'+field)
            if(parrentBlock.attr('data-show') === "true"){
                parrentBlock.attr('data-show',false)
            }else{
                parrentBlock.attr('data-show',true)
            }
        })
    }
})
